import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-ods-input',
  templateUrl: './ods-input.component.html',
  styleUrls: ['./ods-input.component.scss'],
})
export class OdsInputComponent implements OnInit {
  @Input() labelText: string;
  @Input() labelHint: string;
  @Input() labelFor: string;
  @Input() labelId: string;
  @Input() infoTip: string;
  @Input() optional: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  get isRequired(): boolean {
    return /\*/.test(this.labelText ?? '');
  }

  get labelTextBeforeRequired(): string {
    const label = this.labelText ?? '';
    const requiredIndex = label.indexOf('*');
    const text = requiredIndex === -1 ? label : label.slice(0, requiredIndex);

    return this.normalizeLabelText(text);
  }

  get labelTextAfterRequired(): string {
    const label = this.labelText ?? '';
    const requiredIndex = label.indexOf('*');

    if (requiredIndex === -1) {
      return '';
    }

    return this.normalizeLabelText(label.slice(requiredIndex + 1));
  }

  private normalizeLabelText(value: string): string {
    return value.replace(/\s+/g, ' ').trim();
  }
}
